import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";

import { axiosGet, axiosPost } from "../../api/Axios";
import { formatDateInMMDDYYYY, formatDateInYYYYMMDD } from "../../helpers/date";

export const getAllUsersApi = createAsyncThunk(
  "/admin/users/getAllUsers",
  async (query: string, { rejectWithValue }) => {
    try {
      const response = await axiosGet<AllUsersApiResponse>(
        `/admin/users/getAllUsers${query}`
      ); // Replace with your profile endpoint
      return response; // Return the user profile data
    } catch (error) {
      return rejectWithValue(error); // Return the error message
    }
  }
);

export const getUserProfileApi = createAsyncThunk(
  "/admin/users/getUserProfile",
  async (userId: string, { rejectWithValue }) => {
    try {
      const response = await axiosGet<SingleUserApiResponse>(
        `/admin/users/getUserProfile?userId=${userId}`
      ); // Replace with your profile endpoint
      return response; // Return the user profile data
    } catch (error) {
      return rejectWithValue(error); // Return the error message
    }
  }
);

const initialState: IDashboardSliceProp = {
  reloadApiCount: 0,
  errors: [],
  isError: false,
  singleUserProfile: null,
  isTrackingApiLoading: true,
  usersData: {
    totalPages: 0,
    currentPage: 1,
    previousPage: null,
    nextPage: null,
    totalCount: 0,
    pageSize: 50,
    entries: [],
  },
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    reloadProfileApi: (state, action: PayloadAction<boolean>) => {
      state.reloadApiCount++;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getAllUsersApi.pending, (state) => {
        state.isTrackingApiLoading = true;
        state.isError = false; // Reset error
      })
      .addCase(getAllUsersApi.fulfilled, (state, action) => {
        state.isTrackingApiLoading = false;
        state.usersData = action.payload;
        // state.averagePainRatingData = action.payload;
      })
      .addCase(getAllUsersApi.rejected, (state, action) => {
        state.isTrackingApiLoading = false;
        state.isError = true; // Handle error message
        state.errors = [action.payload as string];
      })
      .addCase(getUserProfileApi.pending, (state) => {
        state.isTrackingApiLoading = true;
        state.isError = false; // Reset error
      })
      .addCase(getUserProfileApi.fulfilled, (state, action) => {
        state.isTrackingApiLoading = false;
        state.singleUserProfile = action.payload;
        // state.averagePainRatingData = action.payload;
      })
      .addCase(getUserProfileApi.rejected, (state, action) => {
        state.isTrackingApiLoading = false;
        state.isError = true; // Handle error message
        state.errors = [action.payload as string];
      });
  },
});

export const { reloadProfileApi } = dashboardSlice.actions;

export default dashboardSlice.reducer;
